import loginStore, { loginStateType } from '@/helpers/loginStore';
import { useSyncExternalStore } from 'react';
export const useOpenLoginModal = () => {
  const storage = useSyncExternalStore(loginStore.subscribe, loginStore.getSnapshot, loginStore.getServerSnapshot);
  return {
    loginDrawerState: storage,
    setLoginDrawerState: (state: loginStateType) => {
      loginStore.setState({
        open: state.open,
        message: state === undefined || state.open === false || state.message === undefined ? '' : state.message,
        callback: state === undefined || state.open === false || state.callback === undefined ? undefined : state.callback
      });
    }
  };
};